/* eslint-disable no-unused-vars */
import { BathroomOption, BedroomOption } from '@src/interfaces/app/addProperty';
import { DocumentList } from '@src/interfaces/app/agent/addProperty';
import CreditCheck from '@src/assets/svg/creditCheck';
import Document from '@src/assets/svg/document';
import EmployeVerified from '@src/assets/svg/employeVerified';
import KidsPets from '@src/assets/svg/kidsPets';
import PhotoId from '@src/assets/svg/photoId';
import ReceiptPro from '@src/assets/svg/receiptPro';
import RenterHistory from '@src/assets/svg/rentelHistory';
import VerifiedFinancialsPlace from '@src/assets/svg/verifiedFinancialsPlace';
import Building from '@src/assets/svg/building';
import PersonalCard from '@src/assets/svg/personalCard';
import SimCard2 from '@src/assets/svg/simCard';
import TaskSquare from '@src/assets/svg/taskSquare';
import Card from '@src/assets/svg/card';
import Computing from '@src/assets/svg/computing';
import Teacher from '@src/assets/svg/teacher';
import Briefcase from '@src/assets/svg/briefcase';
import KeySquare from '@src/assets/svg/keySquare';
import DollarSquare from '@src/assets/svg/dollarSquare';
import DocumentText from '@src/assets/svg/documentText';
import Reciept2 from '../assets/svg/recieptItem';

export enum DocumentListEnum {
  PhotoID = 'photo_id',
  RentalHistory = 'residence_history',
  EmploymentVerification = 'employment_verification',
  FinancialDetails = 'financial_details',
  VoucherInformation = 'voucher_information',
  CreditCheck = 'credit_check',
  HouseholdInformation = 'household_information',
}

export enum TemplateDocumentListEnum {
  templateDocument = 'template',
}

export enum OtherDocumentListEnum {
  Paystubs = 'paystubs',
  BankStatements = 'bank_statements',
  // W2Forms = 'w2_form',
  TaxReturns = 'tax_returns',
  LandLordReferenceLetter = 'landlord_reference_letter',
}

export const AllDocumentsListEnum = {
  ...DocumentListEnum,
  ...TemplateDocumentListEnum,
  ...OtherDocumentListEnum,
  Other: 'other',
  RenterUploaded: 'Renter Uploaded',
  CreditAndBackgroudnCheck: 'Credit & Background Check',
  ApplicantSummary: 'Applicant Summary',
  Summary: 'Summary',
} as const;

export enum Utility {
  Gas = 'Gas',
  Water = 'Water',
  Sewage = 'Sewage',
  Garbage = 'Garbage',
  Electricity = 'Electricity',
  Internet = 'Internet',
  SatelliteTV = 'Satellite TV',
  Cable = 'Cable',
}

export enum EditUtility {
  gas = 'Gas',
  sewage = 'Sewage',
  electricity = 'Electricity',
  internet = 'Internet',
  water = 'Water',
  garbage = 'Garbage',
  cable = 'Cable',
  satellite_tv = 'Satellite TV',
}

export const bedroomOptions: BedroomOption[] = [
  { value: '0', label: 'Studio' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  // { value: '5', label: '5' },
];

export const bathroomOptions: BathroomOption[] = [
  { value: '1', label: '1' },
  { value: '1.5', label: '1.5' },
  { value: '2', label: '2' },
  { value: '2.5', label: '2.5' },
  { value: '3', label: '3' },
  // { value: '3.5', label: '3.5' },
];

// it's using in the and Add-property in documents step
export const DocumentGroupList: DocumentList[] = [
  {
    id: DocumentListEnum.PhotoID,
    value: DocumentListEnum.PhotoID,
    label: 'Photo ID',
    icon: PhotoId,
    toolTipText:
      'Asks the applicant to upload a picture or file of their Photo ID.',
  },
  {
    id: DocumentListEnum.RentalHistory,
    value: DocumentListEnum.RentalHistory,
    label: 'Residence History',
    icon: RenterHistory,
    toolTipText:
      'Asks the applicant to provide the last two years of residence history.',
  },
  {
    id: DocumentListEnum.FinancialDetails,
    value: DocumentListEnum.FinancialDetails,
    label: 'Financial Details',
    icon: EmployeVerified,
    toolTipText: `Asks the applicant to provide their employer's name, email, address, annual income, and upload 6 weeks of paystubs or any other supporting documents of their income.`,
  },
  {
    id: DocumentListEnum.CreditCheck,
    value: DocumentListEnum.CreditCheck,
    label: 'Credit Check',
    icon: CreditCheck,
    toolTipText:
      'The applicant will complete a full credit, background, and evictions check through Transunion.',
  },
  {
    id: DocumentListEnum.HouseholdInformation,
    value: DocumentListEnum.HouseholdInformation,
    label: 'Household Information',
    icon: KidsPets,
    toolTipText:
      'Asks the applicant how many people will be living in the home including children, any pets, and what kind of pets.',
  },
];

export const TemplateDocumentList: DocumentList[] = [
  {
    id: TemplateDocumentListEnum.templateDocument,
    value: TemplateDocumentListEnum.templateDocument,
    label: 'Template Document',
    icon: Document,
    toolTipText: '',
  },
];

//TODO: If we need the Paystubs or W2 Forms then we can add here
export const DocumentOtherList: DocumentList[] = [
  {
    id: OtherDocumentListEnum.BankStatements,
    value: OtherDocumentListEnum.BankStatements,
    label: 'Bank Statements',
    icon: VerifiedFinancialsPlace,
    toolTipText:
      'Asks the applicant to provide their most recent bank statements.',
  },
  {
    id: OtherDocumentListEnum.TaxReturns,
    value: OtherDocumentListEnum.TaxReturns,
    label: 'Tax Returns',
    icon: ReceiptPro,
    toolTipText: 'Asks the applicant to provide their most recent tax return.',
  },
];

/**
 * Merge the DocumentGroup and DocumentOther and adding the other key
 * */
export const AllDocumentsList: DocumentList[] = [
  ...DocumentGroupList,
  ...TemplateDocumentList,
  ...DocumentOtherList,
  {
    id: AllDocumentsListEnum.Other,
    value: AllDocumentsListEnum.Other,
    label: '',
    icon: Document,
  },
  {
    id: DocumentListEnum.VoucherInformation,
    value: DocumentListEnum.VoucherInformation,
    label: 'Voucher Information',
    icon: EmployeVerified,
    toolTipText: `Select or Upload Supporting Documents`,
  },
];

export const FEE_TYPES = {
  ONE_TIME: 'ONE_TIME',
  RECURRING: 'RECURRING',
};

export const DOCUMENT_ICONS: Record<
  string,
  React.ComponentType<React.SVGProps<SVGSVGElement>>
> = {
  document_text: DocumentText,
  receipt_2: Reciept2,
  buildings: Building,
  personalcard: PersonalCard,
  simcard_2: SimCard2,
  task_square: TaskSquare,
  card: Card,
  computing: Computing,
  teacher: Teacher,
  briefcase: Briefcase,
  key_square: KeySquare,
  dollar_square: DollarSquare,
};
